import React from 'react';
import PropTypes from 'prop-types';

import { Text } from '@olxbr/ds-web';
import Check from '@olxbr/olx-icons/dist/System/Check';

import CardTitle from './components/CardTitle';
import {
  Wrapper,
  Card,
  TopSeller,
  BuyButton,
  InfoListItem,
  CheckContainer,
} from './styles';
import useCards from './useCards';
import useLoading from '../../hooks/useLoading';

function Cards({
  plansData,
  posData,
  adData,
  extrasData,
}) {
  const loading = useLoading();
  const { onClickBuyButton } = useCards(posData, adData, extrasData, loading);

  function renderInfoList(content, disabled, id) {
    const listKey = index => `${id}-info-${index}`;

    return (
      <div>
        {content.map((item, index) => (
          <InfoListItem key={listKey(index)}>
            <CheckContainer>
              {disabled
                ? <Check
                    color="var(--color-neutral-dark)"
                    width={24}
                    height={24}
                />
                : <Check
                    color="var(--color-feedback-success-light)"
                    width={24}
                    height={24}
                />
              }
            </CheckContainer>
            {item}
          </InfoListItem>
      ))}
      </div>
    );
  }

  function renderPrice(price) {
    const formattedPrice = price && price.toFixed(2).toString().replace('.', ',');

    return <Text.TitleMedium>R$ {formattedPrice} / mês</Text.TitleMedium>;
  }

  return (
    <Wrapper loading={loading.isLoading.toString()} justifyContent="center">
      {plansData.map((data) => {
         const {
          header, info, disabled, id, topSeller, bundleKey,
        } = data;

        return (
          <Card key={bundleKey} isTopSeller={topSeller}>
            {topSeller && <TopSeller>Mais vendido</TopSeller>}
            <CardTitle
              title={header.title}
              description={header.description}
              Icon={header.icon}
              disabled={disabled}
            />
            {renderPrice(header.price)}
            {id !== 'free' && <BuyButton onClick={() => onClickBuyButton(bundleKey)}>Contratar agora</BuyButton>}
            {renderInfoList(info, disabled, id)}
          </Card>
        );
      })
    }
    </Wrapper>
  );
}

Cards.propTypes = {
  plansData: PropTypes.array.isRequired,
  posData: PropTypes.object.isRequired,
  adData: PropTypes.object.isRequired,
  extrasData: PropTypes.object.isRequired,
};

export default Cards;

